// Global Active Editing State Manager
// This prevents ActionCable updates from interfering with active editing sessions

class ActiveEditingManager {
  constructor() {
    this.activeBlocks = new Set();
    this.editingStates = new Map(); // blockId -> { type, startTime, element }
    this.debounceTimeouts = new Map(); // blockId -> timeout
  }

  // Mark a block as actively being edited
  startEditing(blockId, blockType, element) {
    console.log(`🟢 Starting edit session for block ${blockId} (${blockType})`);
    
    this.activeBlocks.add(blockId);
    this.editingStates.set(blockId, {
      type: blockType,
      startTime: Date.now(),
      element: element
    });

    // Add visual indicator
    this.addEditingIndicator(element);
    
    // Clear any existing debounce timeout
    if (this.debounceTimeouts.has(blockId)) {
      clearTimeout(this.debounceTimeouts.get(blockId));
    }
  }

  // Mark a block as no longer being edited (with debounce)
  stopEditing(blockId, debounceMs = 1000) {
    console.log(`🔴 Stopping edit session for block ${blockId} (debounce: ${debounceMs}ms)`);
    
    // Set a debounce timeout to prevent rapid start/stop cycles
    const timeout = setTimeout(() => {
      console.log(`✅ Edit session ended for block ${blockId}`);
      this.activeBlocks.delete(blockId);
      this.editingStates.delete(blockId);
      this.debounceTimeouts.delete(blockId);
      
      // Remove visual indicator
      const state = this.editingStates.get(blockId);
      if (state && state.element) {
        this.removeEditingIndicator(state.element);
      }
    }, debounceMs);

    this.debounceTimeouts.set(blockId, timeout);
  }

  // Check if any block is currently being edited
  isAnyBlockBeingEdited() {
    return this.activeBlocks.size > 0;
  }

  // Check if a specific block is being edited
  isBlockBeingEdited(blockId) {
    return this.activeBlocks.has(blockId);
  }

  // Get all actively edited blocks
  getActiveBlocks() {
    return Array.from(this.activeBlocks);
  }

  // Get editing state for a specific block
  getBlockEditingState(blockId) {
    return this.editingStates.get(blockId);
  }

  // Add visual indicator that block is being edited
  addEditingIndicator(element) {
    // Visual indicators disabled - keeping functionality only
    // if (element) {
    //   element.classList.add('block-being-edited');
    //   element.setAttribute('data-being-edited', 'true');
    // }
  }

  // Remove visual indicator
  removeEditingIndicator(element) {
    // Visual indicators disabled - keeping functionality only
    // if (element) {
    //   element.classList.remove('block-being-edited');
    //   element.removeAttribute('data-being-edited');
    // }
  }

  // Force stop all editing sessions (for cleanup)
  forceStopAll() {
    console.log('🛑 Force stopping all edit sessions');
    this.activeBlocks.clear();
    this.editingStates.clear();
    
    // Clear all timeouts
    this.debounceTimeouts.forEach(timeout => clearTimeout(timeout));
    this.debounceTimeouts.clear();
    
    // Remove all visual indicators
    document.querySelectorAll('.block-being-edited').forEach(element => {
      this.removeEditingIndicator(element);
    });
  }

  // Get debug info
  getDebugInfo() {
    return {
      activeBlocks: Array.from(this.activeBlocks),
      editingStates: Object.fromEntries(this.editingStates),
      totalActive: this.activeBlocks.size
    };
  }
}

// Create global instance
window.activeEditingManager = new ActiveEditingManager();

// Export for use in other modules
export default ActiveEditingManager;
